module.exports = __webpack_public_path__ + "zmenseni-prsou_5_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zmenseni-prsou_5_after_tn.jpg
// module id = 1753
// module chunks = 0